import React from 'react';
import { Link } from 'react-router-dom';
export function PortalFooter() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-brand-dark text-gray-400 py-10 border-t border-gray-800" data-id="element-552">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-553">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 mb-8" data-id="element-554">
          <p className="text-sm" data-id="element-555">
            &copy; {currentYear} Compass Recovery Group, LLC. All rights
            reserved.
          </p>

          <div className="flex items-center gap-6 text-sm" data-id="element-556">
            <Link to="/#" className="hover:text-white transition-colors" data-id="element-557">
              Privacy Policy
            </Link>
            <Link to="/#" className="hover:text-white transition-colors" data-id="element-558">
              Terms of Service
            </Link>
            <Link to="/#" className="hover:text-white transition-colors" data-id="element-559">
              Compliance
            </Link>
          </div>
        </div>

        <div className="bg-gray-900 rounded-lg p-4 text-center border border-gray-800" data-id="element-560">
          <p className="text-xs text-gray-500 font-medium uppercase tracking-wider" data-id="element-561">
            This communication is from a debt collector. This is an attempt to
            collect a debt and any information obtained will be used for that
            purpose.
          </p>
        </div>
      </div>
    </footer>;
}